export default "__VITE_ASSET__ByodYXgD__"